import ConfirmationModal from '../../../components/confirmation-modal';
import PluginAction from '../../plugin-action';

/**
 * Action for (re-)generating the student registration link.
 *
 * @author Philipp Seiler <ps@typoheads.at>
 */
export default class StudentsLinkAction extends PluginAction {
    /**
     * Link for (re-)generating the link.
     */
    private generateLinkLink: HTMLLinkElement;

    constructor(container: HTMLElement) {
        super(container);
        const generateLinkButton = this.container.querySelector<HTMLLinkElement>('[data-action="generateLink"]');
        if (!generateLinkButton) {
            throw new Error('Required elements missing.');
        }
        this.generateLinkLink = generateLinkButton;
        this.initializeModals();
        StudentsLinkAction.emitter.emit('ready', this);
    }

    /**
     * Initializes all modals in this action.
     */
    private initializeModals(): void {
        // Initialize modal to generate a new link
        const generateLinkModal = document.querySelector<HTMLElement>('#generateLinkModal');
        if (generateLinkModal) {
            const generateLinkConfirmation = new ConfirmationModal(generateLinkModal);
            generateLinkConfirmation.emitter.on('confirm', () => {
                window.location.href = this.generateLinkLink.href;
            });

            this.generateLinkLink.addEventListener('click', e => {
                e.preventDefault();
                generateLinkConfirmation.show();
            });
        }
    }
}
